import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { InputComponent } from "@components/input/input.component";
import { PageComponent } from "@components/page/page.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { SubmitButtonComponent } from "@components/submit-button/submit-button.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { SortimentDTO } from "~app/common/models/common/SortimentDTO";
import { SortimentListRequestDTO } from "~app/common/models/sortiment/SortimentListRequestDTO";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { SortimentListComponent } from "./sortiment-list/sortiment-list.component";
import { SortimentRedigeraDialogComponent } from "./sortiment-redigera-dialog/sortiment-redigera-dialog.component";
import { SortimentService } from "./sortiment.service";

@Component({
    selector: "rask-sortiment",
    templateUrl: "./sortiment.component.html",
    styleUrls: ["./sortiment.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        RadiobuttonGroupComponent,
        SubmitButtonComponent,
        SortimentListComponent,
        TranslatePipe
    ]
})
export class SortimentComponent implements OnInit {
    activetypes: IRadiobuttonItem[] = [
        { key: "ja",
            value: "Ja" },
        { key: "nej",
            value: "Nej" },
        { key: "alla",
            value: "Alla" }
    ];
    canCreate: boolean;
    sortiment: SortimentDTO[];
    sortimentForm = new UntypedFormGroup({
        code: new UntypedFormControl(""),
        name: new UntypedFormControl(""),
        productgroup: new UntypedFormControl(""),
        active: new UntypedFormControl("ja")
    });

    private readonly authenticationService = inject(AuthenticationService);
    private readonly busyService = inject(BusyService);
    private readonly modalService = inject(NgbModal);
    private readonly sortimentService = inject(SortimentService);

    create = (): void => {
        if (!this.modalService.hasOpenModals()) {
            const modalRef = this.modalService.open(SortimentRedigeraDialogComponent, {
                keyboard: false,
                backdrop: "static",
                size: "lg"
            });
            modalRef.componentInstance.sortimentId = null;
            modalRef.result.then(result => {
                this.sortiment.push(result);
                modalRef.close(result);
            }, (reason) => {
                // Fånga error
            });
        }
    };

    getAktivNullableBoolean(val: string) {
        return val && val !== "alla" ? (val === "ja") : null;
    }

    ngOnInit() {
        this.canCreate = this.authenticationService.canEdit();
    }

    search() {
        const request = {
            aktiv: this.getAktivNullableBoolean(this.sortimentForm.get("active").value),
            kod: this.sortimentForm.get("code").value,
            namn: this.sortimentForm.get("name").value,
            produktgrupp: this.sortimentForm.get("productgroup").value
        } as SortimentListRequestDTO;
        this.busyService.addWork(this.sortimentService.search(request)).subscribe(response => {
            this.sortiment = response;
        });
    }
}
